module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-registration"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Client Type  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.client_type_id),
      expression: "body.client_type_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "client_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Choose a client type")]), _vm._l((_vm.clientTypes), function(v) {
    return _c('option', {
      domProps: {
        "value": v.id
      }
    }, [_vm._v(_vm._s(v.code))])
  })], 2)], 1)]), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Surname  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.surname),
      expression: "body.surname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "surname", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Email  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.email),
      expression: "body.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "email", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Phone  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.phone),
      expression: "body.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "international prefix call (ex: +39-3951231231)",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "phone", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Mobile  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.mobile),
      expression: "body.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "international prefix call (ex: +39-3951231231)",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "mobile", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Birthdate  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('date-picker', {
    attrs: {
      "placeholder": "insert date"
    },
    model: {
      value: (_vm.body.birthdate),
      callback: function($$v) {
        _vm.$set(_vm.body, "birthdate", $$v)
      },
      expression: "body.birthdate"
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Fiscal code  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.fiscal_code),
      expression: "body.fiscal_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.fiscal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "fiscal_code", $event.target.value)
      }
    }
  })], 1)])]), (_vm.isBusinessAccount) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Vat number  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.vat_number),
      expression: "body.vat_number"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.vat_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "vat_number", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-6 columns"
  }, [_c('label', [_vm._v("Organization name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.organization_name),
      expression: "body.organization_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.organization_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "organization_name", $event.target.value)
      }
    }
  })], 1)])]) : _vm._e(), _vm._m(1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.street),
      expression: "body.address.street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "street", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.city),
      expression: "body.address.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "city", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.region),
      expression: "body.address.region"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.address.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "region", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('selectize-country', {
    on: {
      "optionSelected": _vm.setAddressCountry
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.postal_code),
      expression: "body.address.postal_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "postal_code", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('div', {
    staticClass: "switch large"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "yes-no",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.address) ? _vm._i(_vm.address, null) > -1 : (_vm.address)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.address,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.address = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.address = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.address = $$c
        }
      }
    }
  }), _vm._m(3)])])]), (!_vm.address) ? _c('div', [_vm._m(4), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.billing_address.street),
      expression: "body.billing_address.street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.billing_address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.billing_address, "street", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.billing_address.city),
      expression: "body.billing_address.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.billing_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.billing_address, "city", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.billing_address.region),
      expression: "body.billing_address.region"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.billing_address.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.billing_address, "region", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('selectize-country', {
    on: {
      "optionSelected": _vm.setBillingAddressCountry
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.billing_address.postal_code),
      expression: "body.billing_address.postal_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.billing_address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.billing_address, "postal_code", $event.target.value)
      }
    }
  })], 1)])])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('div', {
    staticClass: "switch large"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document),
      expression: "document"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "add-document",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.document) ? _vm._i(_vm.document, null) > -1 : (_vm.document)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.document,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.document = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.document = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.document = $$c
        }
      }
    }
  }), _vm._m(6)])])]), (_vm.document) ? _c('backoffice-driver-license-create', {
    on: {
      "driverLicenseUpdated": _vm.setDriverLicenseFields
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('ClientExtraFields', {
    attrs: {
      "fields": _vm.body.extra
    }
  })], 1)]), _vm._m(7)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Personal information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row column"
  }, [_c('hr'), _c('h2', [_vm._v("Residential Address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 large-4 large-offset-3 columns"
  }, [_c('label', [_vm._v("Is billing address the same as the residential address?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "yes-no"
    }
  }, [_c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Billing address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 large-4 large-offset-3 columns"
  }, [_c('label', [_vm._v("Add document?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "add-document"
    }
  }, [_c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('label', [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2c9de18!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateClient.vue
// module id = 2635
// module chunks = 1